// extracted by mini-css-extract-plugin
module.exports = {"container-popover-notification":"NotificationPanel_container-popover-notification__a73cx"};